import { api } from '@shared/config/axiosConfig';
import { mapPaginationResponse } from '@shared/utils/mapPaginationResponse';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { municipalityFromDto } from '../mappers/municipalitiesMapper';

const BASE_ENDPOINT = 'location/municipality';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
}

export const getMunicipality = async (id) => {
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.get(endpoint);
  return municipalityFromDto(response.data);
}

export const getMunicipalities = async (data = {}) => {
  const params = {
    search_text: data.searchText,
    ids: data.ids,
    codes: data.codes,
    department_id: data.departmentId,
    page: data.page,
    page_size: data.pageSize,
  };

  const endpoint = buildServiceEndpoint();
  const response = await api.get(endpoint, { params });
  return mapPaginationResponse(response, municipalityFromDto);
};